var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-check-in-6432169",
    d: "M121.126,119.5H113a.5.5,0,0,1,0-1h8.126l-1.147-1.147a.5.5,0,0,1,.707-.707l2,2a.5.5,0,0,1,0,.707l-2,2a.5.5,0,0,1-.707-.707l1.147-1.147Zm3.207-7H119a1.168,1.168,0,0,0-1.167,1.167V115a.5.5,0,0,0,1,0v-1.333A.167.167,0,0,1,119,113.5h5.333a.167.167,0,0,1,.167.167v10.667a.167.167,0,0,1-.167.167H119a.167.167,0,0,1-.167-.167V123a.5.5,0,0,0-1,0v1.333A1.168,1.168,0,0,0,119,125.5h5.333a1.168,1.168,0,0,0,1.167-1.167V113.667A1.168,1.168,0,0,0,124.333,112.5Z",
    transform: "translate(-112.5 -112.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/checkIn.12b4324f8f50dd9bb90f813738176e0a.svg";
export { ForwardRef as ReactComponent };